import React from 'react';
import { findDOMNode } from 'react-dom';
import { isBrowser, isMobile } from 'react-device-detect';
import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import globals from '../../globals';

export default {

    destroy(controller) {
        controller.destroy(true);
    },

    initialise(Careers) {
        if (!Careers.titleRef || !Careers.subTitleRef) {
            return;
        }

        this.CareersNode = findDOMNode(Careers);
        let controller = new ScrollMagic.Controller(),
            tl = new TimelineLite(),
            benefitsTl = new TimelineLite(),
            benefits = [...this.CareersNode.getElementsByClassName('benefit-item')];

        tl.fromTo(Careers.titleRef, 0.75, {x: 500, opacity: 0}, {x: 0, opacity: 1, ease: Back.easeOut.config(3)})
            .fromTo(Careers.subTitleRef, 1, globals.getSubAnimation(Careers.subTitleRef), {backgroundPositionY: "0px", ease: Elastic.easeOut.config(1, 0.4)})

        new ScrollMagic.Scene({
            triggerElement: '.careers-trigger',
            reverse: false
        })
            .setTween(tl)
            .addTo(controller);

        if (isBrowser) {
            new ScrollMagic.Scene({
                triggerElement: '.benefits-trigger',
                reverse: false
            })
                .setTween(benefitsTl)
                .addTo(controller);

            benefits.sort(() => {
                return 0.5-Math.random();
            });

            benefitsTl.staggerFromTo(benefits, 0.3, {opacity: 0, scale: 0.5}, {opacity: 1, scale: 1, ease: Power1.easeOut}, 0.1);

            new ScrollMagic.Scene({
                triggerElement: '.benefits-trigger',
                reverse: false
            })
                .setTween(benefitsTl)
                .addTo(controller);

            new ScrollMagic.Scene({
                triggerElement: '.careers',
                duration: '2000px'
            })
                .setTween(this.CareersNode, {backgroundPosition: '-65px 100px'})
                .addTo(controller);
        }

        return controller;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Careers/animations.js